import { render, staticRenderFns } from "./Control.vue?vue&type=template&id=22b6d338&scoped=true"
import script from "./Control.vue?vue&type=script&lang=ts"
export * from "./Control.vue?vue&type=script&lang=ts"
import style0 from "./Control.vue?vue&type=style&index=0&id=22b6d338&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b6d338",
  null
  
)

export default component.exports